// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.heart-box .like-icon[data-v-331476cc]{\n  color: #dc3232;\n}\n.heart-box .unlike-icon[data-v-331476cc]{\n  color: #d9d9d9;\n}\n.lnk-consutant-more[data-v-331476cc]:hover {\n  background-color: #82c1ea;\n}\n", ""]);
// Exports
module.exports = exports;
